import { EndpointGroup } from 'modules/endpoints/types';

import { GRPCEndpoint } from './components/GRPCEndpoint';
import { useGRPCEndpointsStyles } from './useGRPCEndpointsStyles';
import { GRPCCodeExample } from './components/GRPCCodeExample';
import { useGRPCEndpoints } from './useGRPCEndpoints';

interface GRPCEndpointsProps {
  group: EndpointGroup;
  userEndpointToken: string;
}

export const GRPCEndpoints = ({
  group,
  userEndpointToken,
}: GRPCEndpointsProps) => {
  const { classes } = useGRPCEndpointsStyles();
  const { shouldRender, sortedUrls } = useGRPCEndpoints({
    group,
  });

  if (!shouldRender) {
    return null;
  }

  return (
    <div className={classes.root}>
      {sortedUrls.map(url => (
        <div className={classes.item} key={url}>
          <GRPCEndpoint url={url} xToken={userEndpointToken} />
          <GRPCCodeExample url={url} xToken={userEndpointToken} />
        </div>
      ))}
    </div>
  );
};
